import React from 'react';
import ExecutivePostureRow from './ExecutivePostureRow';
import CanvasPreview from './CanvasPreview';
import ChatPreview from './ChatPreview';
import WorktreePreview from './WorktreePreview';
import InsightAlerts from './InsightAlerts';

export default function EnterpriseOverview({ model }) {
  if (!model) return null;

  const { posture, previews, alerts } = model;

  return (
    <div className="space-y-6" data-testid="enterprise-overview-surface">
      {/* 1. Executive Posture Row (6 Top Metrics) */}
      <section aria-label="Executive Posture Metrics">
        <ExecutivePostureRow posture={posture} />
      </section>

      {/* 2. Intelligence & Collaboration Surface Previews (3-Column Grid) */}
      <section aria-label="Execution Intelligence Previews">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          <CanvasPreview preview={previews?.canvas} />
          <ChatPreview preview={previews?.chat} />
          <WorktreePreview preview={previews?.worktree} />
        </div>
      </section>

      {/* 3. Deterministic Insights & Alerts */}
      <section aria-label="Insights and Alerts">
        <InsightAlerts alerts={alerts} />
      </section>
    </div>
  );
}
